export default {
  header: 'New orders paused',
  text: 'Tap anywhere to restore',
};
